import { Types } from '../../../actions/dashboards'
import { Metrics } from '../../../constants/Dashboards'
import { DateUtils } from '../../../utils'
import buildAsyncStatReducer from './asyncStatReducer'

/**
 * Notes Latest
 */
const notesLatest = buildAsyncStatReducer({
    key: Metrics.NOTES_LATEST,
    types: {
        request: Types.DASHBOARD_NOTES_LATEST.request,
        success: Types.DASHBOARD_NOTES_LATEST.success,
        failure: Types.DASHBOARD_NOTES_LATEST.failure,
    },
    transform: (state, { payload }) => {
        const { created_at: createdAt, id, note, store_code: storeCode, user_name: username } = payload[0] || {}
        return {
            createdAt: DateUtils.UTCDateToTimestamp(createdAt),
            id,
            note,
            storeCode,
            username,
        }
    },
})

const devicesReducers = [notesLatest]

export default devicesReducers
